import { render, staticRenderFns } from "./ActionsEditor.vue?vue&type=template&id=87c5ea32&scoped=true"
import script from "./ActionsEditor.vue?vue&type=script&lang=js"
export * from "./ActionsEditor.vue?vue&type=script&lang=js"
import style0 from "./ActionsEditor.vue?vue&type=style&index=0&id=87c5ea32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c5ea32",
  null
  
)

export default component.exports